import { HTMLAttributes } from 'react'

const Review = (props: HTMLAttributes<HTMLDivElement>) => (
  <div
    className="relative flex flex-col gap-2 pb-4 mb-4 border-b first:mt-1 last-of-type:border-b-0 last-of-type:pb-0"
    {...props}
  />
)

export default Review
